import { render, staticRenderFns } from "./PostingTypeForm.vue?vue&type=template&id=6166637a"
import script from "./PostingTypeForm.vue?vue&type=script&lang=js"
export * from "./PostingTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports